import Http from "./Http";

import queryString from "query-string";

export class PaymentsService extends Http {
  /**
   * Get list of subscriptions
   * @param {Object} params
   * @param {number} params.limit
   * @param {number} params.offset
   * @param {number} params.startDate
   * @param {number} params.endDate
   * @param {number} params.priceType 1 -USD, 2 - MATIC
   * @param {number} params.status 1 - success, 2 - failed
   * @param {number} params.orderBy createdAt, nextPaymentAt, price
   * @param {number} params.orderType asc, desc
   * @param {number} params.status 1 - active, 2 - canceled, 3 - expired, 4 - notAvailable, 5 - pending, 6 - incomplete
   * @param {number} params.isIncome default false
   *
   */
  getListSubscriptions(params) {
    return this.get("/payments/subscriptions", {
      params,
      paramsSerializer: (params) =>
        queryString.stringify(params, {
          skipEmptyString: true,
          skipNulls: true,
        }),
    });
  }

  /**
   * Get list of content requests
   * @param {Object} params
   * @param {number} params.limit
   * @param {number} params.offset
   * @param {number} params.orderBy createdAt, totalSum
   * @param {number} params.orderType asc, desc
   */
  getListContentRequests(params) {
    return this.get("/payments/content-requests", {
      params,
      paramsSerializer: (params) =>
        queryString.stringify(params, {
          skipEmptyString: true,
          skipNulls: true,
        }),
    });
  }

  /**
   * Get list of donations
   * @param {Object} params
   * @param {number} params.limit
   * @param {number} params.offset
   * @param {number} params.startDate
   * @param {number} params.endDate
   * @param {number} params.priceType 1 - USD, 2 - MATIC
   * @param {number} params.orderBy createdAt, nextPaymentAt, price
   * @param {number} params.orderType asc, desc
   * @param {number} params.type 1 - donation, 2 - subscription, 3 - post
   * @param {number} params.isIncome default false
   */
  getListDonations(params) {
    return this.get("/payments/donations", {
      params,
      paramsSerializer: (params) =>
        queryString.stringify(params, {
          skipEmptyString: true,
          skipNulls: true,
        }),
    });
  }

  /**
   * Create instance of crypto transaction
   * @param {object} body
   * @param {number} body.type 1 - donation, 2 - subscription, 3 - post
   * @param {number} body.amount
   * @param {number} body.postId
   * @param {number} body.recipientId
   * @param {number} body.subscriptionId
   * @param {number} body.userSubscriptionId
   * @param {number} body.durationType 1 - monthly,  2 - semiAnnual,  3 - annual
   * @returns
   */
  createCryptoTxInstance(body) {
    return this.post("/payments/cryptocurrencies", body);
  }

  /**
   *
   * @param body
   * @param {number} body.amount
   * @returns {*}
   */
  withdraw(body) {
    return this.post("/payments/withdrawals", body);
  }

  /**
   * Update transaction hash for crypto transaction
   * @param {number} id
   * @param {object} body
   * @param {string} body.transactionHash
   */
  updateCryproTxHash(id, body) {
    return this.patch(`/payments/${id}/transaction-hash`, body);
  }

  /**
   * Get list of agency bonuses
   * @param {Object} params
   * @param {number} params.limit
   * @param {number} params.offset
   */
  getAgencyUsers(params) {
    return this.get("/payments/agency/users", {
      params,
      paramsSerializer: (params) =>
        queryString.stringify(params, {
          skipEmptyString: true,
          skipNulls: true,
        }),
    });
  }
  /**
   * Get list of agency bonuses
   * @param {Object} params
   * @param {number} params.limit
   * @param {number} params.offset
   * @param {string} params.startDate
   * @param {string} params.endDate
   * @param {number} params.type 1 - donation, 2 - subscription, 3 - post
   * @param {number} params.status 1 - success, 2 - failed, 3 - pending
   * @param {string} params.orderBy Order fields: amount, createdAt
   * @param {number} params.orderType Order types: asc, desc
   */
  getAgency(params) {
    return this.get("/payments/agency", {
      params,
      paramsSerializer: (params) =>
        queryString.stringify(params, {
          skipEmptyString: true,
          skipNulls: true,
        }),
    });
  }
  /**
   * Get list of promotions
   * @param {Object} params
   * @param {number} params.limit
   * @param {number} params.offset
   * @param {string} params.startDate
   * @param {string} params.endDate
   * @param {number} params.type 1 - donation, 2 - subscription, 3 - post
   * @param {number} params.status 1 - success, 2 - failed, 3 - pending
   * @param {string} params.orderBy Order fields: amount, createdAt
   * @param {number} params.orderType Order types: asc, desc
   */
  getPromotions(params) {
    return this.get("/payments/promotions", {
      params,
      paramsSerializer: (params) =>
        queryString.stringify(params, {
          skipEmptyString: true,
          skipNulls: true,
        }),
    });
  }
  /**
   * Get payment token
   * */
  createPaymentToken() {
    return this.post("/ccbill/token");
  }

  /**
   * Post card token
   * @param {Object} params
   * @param {string} params.cardToken
   * */
  postCardToken(params) {
    return this.post("/cards", params);
  }

  /**
   * Get payout countries
   **/
  getPayoutCountries() {
    return this.get("/payments/withdrawals/countries");
  }

  /**
   * Get withdrawals methods
   * @param {Object} params
   * @param {string} params.countryAlpha3
   * @param {string} params.payer
   **/
  getWithdrawalsMethods(params) {
    return this.get(`/payments/withdrawals/methods`, { params });
  }

  /**
   * Add payout method
   * @param {Object} body
   * @param {string} body.countryAlpha3
   * @param {{type: string, value: string}[]} body.attributes
   **/
  addPayoutMethod(body) {
    return this.post(`/payments/withdrawals/methods`, body);
  }

  /**
   * Disconnect payout method
   **/
  disconnectPayoutMethod() {
    return this.delete("/payments/withdrawals/methods");
  }

  /**
   * Get Content Request Checkout ID
   **/
  getContentRequestCheckoutId({ username, body }) {
    return this.post(`/request-content-form/${username}/checkouts`, body);
  }
}

PaymentsService.$displayName = "PaymentsService";

export default new PaymentsService();
